import styled from 'styled-components';

import Text from '../base-text/variants/text';
import Image, { type ImageProps } from '../image/image';
import type { WithClassNameProps } from '../types';

type StickerItemVariant = 'list' | 'block';

const Container = styled.div<{ $variant: StickerItemVariant }>`
  display: flex;
  align-items: center;
  ${({ $variant }) => $variant === 'block' && 'flex-direction: column'};
`;

const TextWrapper = styled.div<{ $variant: StickerItemVariant }>`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  ${({ $variant }) =>
    $variant === 'block' &&
    `
    margin-left: 0;
    margin-top: 10px;
    > * {
      text-align: center
    }
  `};
`;

const StyledTitle = styled(Text.MDBold)`
  margin-bottom: 5px;
`;

export type StickerItemProps = WithClassNameProps &
  Pick<ImageProps, 'src' | 'double' | 'triple' | 'alt'> & {
    title: string;
    text: string;
    variant?: StickerItemVariant;
  };

const sizeByVariant: Record<StickerItemVariant, number> = {
  list: 60,
  block: 100,
};

const StickerItem = ({ src, double, triple, alt, title, text, className, variant = 'list' }: StickerItemProps) => (
  <Container className={className} $variant={variant}>
    <Image
      src={src}
      double={double}
      triple={triple}
      alt={alt}
      width={sizeByVariant[variant]}
      height={sizeByVariant[variant]}
    />
    <TextWrapper $variant={variant}>
      <StyledTitle>{title}</StyledTitle>
      <Text.SM>{text}</Text.SM>
    </TextWrapper>
  </Container>
);

export default StickerItem;
